import { render } from "./ObjectiveDetail.vue?vue&type=template&id=38efc39e&scoped=true"
import script from "./ObjectiveDetail.vue?vue&type=script&lang=js"
export * from "./ObjectiveDetail.vue?vue&type=script&lang=js"

import "./ObjectiveDetail.vue?vue&type=style&index=0&id=38efc39e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38efc39e"]])

export default __exports__